module.exports = __webpack_public_path__ + "static/media/iso_logo.07c30652.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/iso_logo.jpg
// module id = 580
// module chunks = 0